import { Outlet } from 'react-router-dom';

const Layout = () => {
	return (
		<div className="flex flex-col min-h-lvh min-w-[100vw] bg-rcrm-primary-bg relative">
			<Outlet />
		</div>
	);
};

export default Layout;
